import script from "./HomeHaederBG.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHaederBG.vue?vue&type=script&setup=true&lang=js"

import "./HomeHaederBG.vue?vue&type=style&index=0&id=b5d7fcbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d7fcbc"]])

export default __exports__